import React from 'react';
import DataGrid, { Column, ColumnChooser, ColumnFixing } from 'devextreme-react/data-grid';
// import data from '../../data/wordcloud_keyword_with_metrics.json';
import { SubAccount, ClientsAPI } from 'src/api'



const COLUMNS = ['value', 'count', 'Clicks', 'Conversions', 'Cost', 'avg_cpm', 'avg_cpc', 'avg_cpa']
const COLOR = '#1c558e'

type DataType = {
  value: string,
  count: number,
  Clicks: number,
  Conversions: number,
  Cost: number,
  avg_cpm: number,
  avg_cpc: number,
  avg_cpa: number
}

type TableProps = {
  client?: SubAccount
}

const getColorRanges = (data: DataType[]|any): number[][] => {
  const colorRanges = COLUMNS.map(col => {
    if (col === 'value') return []

    // x['count'] x.count
    const sorted = data
      .map((x: DataType) => x[col])
      .sort((a: number, b: number) => a - b);

    return [sorted[0], sorted[sorted.length - 1]];
  })

  return colorRanges
}

const getCaption = (col: string) => {
  switch (col) {
    case 'value':
      return 'Keywords';
    case 'count':
      return 'Impression';
    case 'avg_cpm':
      return 'CPM';
    case 'avg_cpc':
      return 'CPC';
    case 'avg_cpa':
      return 'CPA';
    default:
      return col;
  }
}


// console.log(colorRanges);

// [1, 11] 6 -> [0, 10] 5 -> 5 / 10 -> 0.5
// [mxxxVxxxM] -> 50% -> 128 -> 0x80 -> #ffffff80


class TableKeyword extends React.Component<TableProps> {
  state = {
    data: undefined,
    // narrative: undefined
  }
  fetchData = (client: SubAccount) => {
    const params = {
      narrative_assembly_id: "3870d92a-e82c-11ea-86cf-0e95a518f8f7",
      report_content_id: "16ce3654-efc5-11ea-86cf-0e95a518f8f7",
      sub_account_id: client.id,
      period_index: "1449",
      period_type: "monthly"
    }

    ClientsAPI.getReportData(client, 'wordcloud_keyword_with_metrics.json').then(result => {
      // console.log('done', result)
      this.setState({ data: result.data });
    }).catch(error => {
      // console.log('error', error)
    })

    // ClientsAPI.getNarrative(client, params).then(result => {
    //   // console.log('done', result)
    //   this.setState({ narrative: result[0] });
    // }).catch(error => {
    //   // console.log('error', error)
    // })
  }



  render() {

    const { data } = this.state
    const { client } = this.props;
    // const { narrative } = this.state
    if (!data && client) {
      this.fetchData(client);
    }

    if (!data) return null;


    const colorRanges = getColorRanges(data);
  
    const getBackgroundColor = (column: string, value: number) => {
      const columnIndex = COLUMNS.indexOf(column);
      const colorRange = colorRanges[columnIndex];
      const [min, max] = colorRange;
      const colorWeight = (value - min) / (max - min);
      const color = COLOR + Math.ceil(128 + colorWeight * 127).toString(16);
      const opacity = (128 + colorWeight * 127) / 255
      return [color, opacity];
    }
    return (
      <DataGrid
        dataSource={data}
        showBorders={true}
      >
        {COLUMNS.map(col => (
          <Column
            key={col}
            dataField={col}
            caption={getCaption(col)}
            alignment='center'
            cellRender={cell => {
              if (col !== 'value') {
                const [backgroundColor, opacity] = getBackgroundColor(col, cell.data[col]);
                cell.cellElement.style.backgroundColor = backgroundColor
                if (opacity > 0.9) {
                  cell.cellElement.style.color = '#ddd'
                }
              }
              return cell.data[col];
            }}
          />
        ))}
      </DataGrid>
    );
  }
}

export default TableKeyword


// WEBPACK FOOTER //
// ./src/components/ReportComponents/TableKeyword.tsx